/**
 * 배너 슬라이더(.promo-slider).
 *
 * 파트너 화면 옆줄(소식 · 케어 · 직원)에 배너가 둘 이상일 때만 만들어진다.
 * 마크업은 template-parts/partner-aside.php 가 낸다.
 *
 * 카드 껍데기(.promo)는 슬라이더 바깥에 있어 제자리에 머문다. 넘어가는 것은
 * 안쪽 내용(.promo__inner)뿐이라 테두리·그림자가 흔들리지 않는다.
 *
 * 그림 덩어리(.promo__figure)와 글 덩어리(.promo__body)가 서로 다른 속도로
 * 따라 들어온다(Parallax). 이동 값은 promo.php 의 data-swiper-parallax 에 있다.
 *
 * 슬라이드를 미리 복제해 두지 않는다. Swiper 9 부터 loop 는 복제본을 만들지 않고
 * 있는 요소를 앞뒤로 옮겨 쓰기 때문에, 한 장씩 넘기는 이 자리에서는 두 장만 있어도
 * 자연스럽게 돈다. 복제하면 같은 배너가 여러 번 집계된다.
 */

import Swiper from 'swiper';
import { Autoplay, Parallax } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/autoplay';

const build = (el) => {
  const wrapper = el.querySelector('.swiper-wrapper');

  // 한 장뿐이면 돌릴 것이 없다. PHP 가 이미 걸러 주지만 여기서도 막아 둔다.
  // (loop 는 slidesPerView 1 기준으로 최소 두 장이 있어야 켜진다)
  if (!wrapper || wrapper.children.length < 2) {
    return;
  }

  // 화면 움직임을 줄여 달라고 한 사용자에게는 자동 넘김도 시차 효과도 걸지 않는다.
  const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  new Swiper(el, {
    modules: [Autoplay, Parallax],
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    speed: 850,
    // 카드 껍데기가 고정이라 내용 높이가 다르면 카드가 늘고 준다. 그 변화를 부드럽게.
    autoHeight: true,
    // 그림 덩어리와 글 덩어리가 서로 다른 속도로 따라 들어온다.
    // Swiper 14 에서 parallax 는 객체를 받는다. parallax: true 로 두면
    // params.parallax.enabled 가 undefined 라 아무 일도 일어나지 않는다.
    parallax: { enabled: !calm },
    autoplay: calm ? false : { delay: 6000, disableOnInteraction: false, pauseOnMouseEnter: true },
  });
};

const InitPromoSlider = () => {
  document.querySelectorAll('[data-promo-slider]').forEach(build);
};

export default InitPromoSlider;
